
@for (el of cartPrices; track el; let i = $index) {
  <tw-cart-line [cartPrice]="el" [location]="location"></tw-cart-line>
}
